import { useQuery } from '@tanstack/react-query';
import { queryFetch } from '@services/api';
import { queryKeys } from '@utils/consts';
import { ApiError } from '@root/globalTypes';
import { useAppContext } from '@contexts/app';
import { PanelDropdownRespSuccess } from '../types';
import { usePanel } from '@hooks/usePanel';
import { useParams } from 'react-router';
import { useQueryParams } from '@hooks/queryParams';
import { useFeatureFlag } from '@hooks/useFeatureFlag';

export const usePanelMaterialsTagsDropdown = () => {
  const {
    admin: { isLogged },
  } = useAppContext();
  const { enabled: flatworkPanelEnabled } = useFeatureFlag('flatwork_panel');

  const { panel } = usePanel();
  const { tenantId } = useParams();
  const { parseParams } = useQueryParams();

  const queryParams = parseParams({ tenantId });

  const { data, error, isPending } = useQuery<PanelDropdownRespSuccess, ApiError>({
    queryKey: [...queryKeys.dropdowns.panel.materialsTags, queryParams],
    queryFn: () => queryFetch({ url: `dropdowns/materials_tags${queryParams}`, panel }),
    placeholderData: (previousData) => previousData as PanelDropdownRespSuccess,
    enabled: isLogged && panel && !!tenantId && flatworkPanelEnabled,
    retry: 2,
  });

  return {
    data,
    error,
    isLoading: isPending && isLogged && panel && !!tenantId && flatworkPanelEnabled,
  };
};
